'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ShareItem;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _displayTypes = require('./displayTypes');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Share count number is only being shown if greater than this constant.
 * @const {number}
 */
var minimumShares = 30;

ShareItem.propTypes = {
  displayType: _react2.default.PropTypes.oneOf([_displayTypes.HORIZONTAL_ICONS, _displayTypes.VERTICAL_BUTTONS]),
  inverted: _react2.default.PropTypes.bool,
  type: _react2.default.PropTypes.string,
  count: _react2.default.PropTypes.number,
  description: _react2.default.PropTypes.string,
  shareUrl: _react2.default.PropTypes.string
};

/**
 * A share item is a single sharing item, consisting of a link with an icon.
 * Using display types, this item can be displayed in different ways, either
 * as a list item or as a button.
 *
 * @param {string} props.displayType - Either {@see HORIZONTAL_ICONS} or {@see VERTICAL_BUTTONS}.
 * @param {boolean} props.inverted - If share items should be shown inverted.
 * @param {string} props.type - Can currently be facebook or twitter.
 * @param {number} props.count - Number of shares, if available.
 * @param {string} props.description - Description – used as activator («Auf
 * Twitter teilen»)
 * @param {string} props.shareUrl - The action URL that should be opened
 * when clicking the button link.
 * @returns {XML}
 */
function ShareItem(props) {
  var itemClass = props.type + ' share',
      innerText = void 0;

  switch (props.displayType) {
    case _displayTypes.HORIZONTAL_ICONS:
      itemClass = itemClass + ' item';

      innerText = props.count >= minimumShares ? props.count : '';
      break;

    case _displayTypes.VERTICAL_BUTTONS:
      itemClass = itemClass + ' ui button';
      innerText = props.description;
      break;

  }

  return _react2.default.createElement(
    'a',
    { href: props.shareUrl,
      title: props.description,
      className: itemClass,
      target: '_top' },
    _react2.default.createElement('i', { className: props.type + ' icon' }),
    innerText
  );
}


//////////////////
// WEBPACK FOOTER
// ./~/ta-react-share-buttons/dist/shareItem.js
// module id = 362
// module chunks = 0